import { NewPasswordForm } from '@shared/features/auth/components/NewPasswordForm';

export default function ResetPasswordPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-center">
        <NewPasswordForm />
      </div>
    </div>
  );
}
